import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
// import SvgIcon from '@material-ui/core/SvgIcon';

type Props = {
  [key: string]: any;
};

function IconVietNamFlag(props: Props) {
  return (
    <SvgIcon {...props} style={{ fill: 'none' }} viewBox="0 0 30 20">
      <rect {...props} fill="#da251d" />
      <polygon points="15,4 11.47,14.85 20.71,8.15 9.29,8.15 18.53,14.85" fill="#ff0" />
    </SvgIcon>
  );
}

export default React.memo(IconVietNamFlag);
